import { ExecutionStatus } from '../../../../Types/LogT';

export type ReportExecutionState = 'COMPLETED' | 'PLANNED' | 'SKIPPED' | 'NOT_EXECUTED';

export const getReportExecutionState = (status?: ExecutionStatus): ReportExecutionState => {
  if (status === 'COMPLETED' || status === 'FULFILLED') {
    return 'COMPLETED';
  }

  if (status === 'SKIPPED') {
    return 'SKIPPED';
  }

  if (status === 'FAILED' || status === 'PRECONDITION_FAILED' || status === 'ABORTED') {
    return 'NOT_EXECUTED';
  }

  return 'PLANNED';
};
